<template>
    <div class="mt-2 mb-2 ml-3">
        <div v-if="logs.length" class="mt-2">
            <div
                class="title mt-2 mb-4 pb-2 layout row"
                style="text-decoration: underline;"
            >
                Change Logs
            </div>

            <v-divider class="pb-1"></v-divider>
            <v-layout row class="my-2">
                <div class="width-220 font-weight-medium">Date</div>
                <div class="width-120 font-weight-medium">Key</div>
                <div class="font-weight-medium" style="width: 500px;">
                    Changes
                </div>
                <div class="width-100 font-weight-medium">Action</div>
                <div class="width-150 font-weight-medium">User</div>
            </v-layout>
            <v-divider class="pb-1"></v-divider>
            <div class="" v-for="(log, index) in logs">
                <v-layout row class="my-2">
                    <div class="width-220">
                        {{ log.dateTime | time }}
                    </div>
                    <div class="width-120">
                        {{ log.keyValues }}
                    </div>
                    <div style="width: 500px; white-space: normal;">
                        {{ log.changes }}
                    </div>
                    <div class="width-100">{{ log.action }}</div>
                    <div class="width-150">{{ log.userName }}</div>
                </v-layout>
                <v-divider
                    class="pb-1"
                    v-if="index + 1 < logs.length"
                ></v-divider>
            </div>
        </div>
        <div class="title mt-0" v-if="!loading && !logs.length">
            No Change Logs
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, sum } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            loading: true,
            logs: [],
        };
    },
    async created() {
        this.loadLogs();
    },
    computed: {},
    methods: {
        async loadLogs() {
            if (!this.row.id) return;

            const response = await this.$http.get(
                "api/hsStudents/GetChangeLogs?id=" + this.row.id,
            );

            this.loading = false;

            this.logs = response;
        },
        // getRowProperties() {
        //     return Object.keys(
        //         except(
        //             this.match,
        //             "vgt_id",
        //             "originalIndex",
        //             "vgtExpended",
        //         )
        //     )
        //         .map((key) => {
        //             const column = this.columns
        //                 .filter((c) => !c.isIcon)
        //                 .find((c) => c.field == key);

        //             return {
        //                 name: column ? column.label : toTitleCase(key),
        //                 value: this.row[key],
        //             };
        //         })
        //         .filter((p) => p.value);
        // },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
    },
};
</script>
<style></style>
